<template>
  <div class="container mt-2 position-relative">
    <div class="d-flex align-items-center w-100 gap-2">
      <div class="d-flex align-items-center position-relative w-100 gap-2">
        <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" class="position-absolute top-50 start-0 translate-middle-y ms-2" style="pointer-events: none">
          <path d="M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
        
        <input
          id="buscadorPersona"
          type="text"
          class="form-control m-0 rounded-3 borde-terciario fondo-terciario sombra-sm"
          :placeholder="t('buscarEmpleadoPorNombreLegajo') + '...'"
          v-model="searchQuery"
          style="padding-left: 35px;"
          @focus="isDropdownOpen = true"
          @blur="cerrarDropdown"
        />
        
        <button
          v-if="searchQuery"
          type="button"
          class="position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent"
          @click="limpiarSeleccion" 
        >
          <i class="bi bi-x texto-secundario" style="font-size: 30px;"></i>
        </button>
        
        <ul
          v-if="isDropdownOpen && personasFiltradas.length > 0"
          class="dropdown-menu show w-100 sombra-sm mt-2 border-0 fondo-terciario p-0"
          style="max-height: 250px; overflow-y: auto; position: absolute; top: 100%; left: 0; z-index: 1050;"
        >
          <li v-for="persona in personasFiltradas" :key="persona.IdPersona">
            <button
              class="dropdown-item py-2 border-bottom texto-principal fondo-terciario"
              @click.prevent="seleccionarPersona(persona)"
            >
              {{ persona.Apellido }}, {{ persona.Nombre }}
              <span class="badge fondo-terciario sombra-sm texto-principal border ms-2">{{ $t('legajo') + ': ' + persona.LegajoIdEmpleado }}</span>
              <span v-if="persona.SectorNivel" class="badge fondo-terciario sombra-sm texto-principal border ms-2">{{ persona.SectorNivel }}</span>
            </button>
          </li>
        </ul>
        
        <ul
          v-else-if="isDropdownOpen && searchQuery && personasFiltradas.length === 0"
          class="dropdown-menu show w-100 sombra mt-2 border-0 fondo-terciario"
          style="position: absolute; top: 100%; left: 0; z-index: 1050;"
        >
          <li><span class="dropdown-item texto-secundario">{{ t('noResultados') }}</span></li>
          <li><span class="dropdown-item texto-secundario">({{ t('usuariosSinHorarioOFichadasNoApareceran') }})</span></li>
        </ul>
        
      </div>

      <button 
        v-if="hasManejarHorariosPermission"
        class="btn btn-outline-danger sombra d-flex align-items-center gap-2 text-nowrap" 
        @click="descargarPdf"
        :disabled="exportandoPdf"
      >
        <span v-if="exportandoPdf" class="spinner-border spinner-border-sm"></span>
        <i v-else class="bi bi-file-earmark-pdf"></i>
        {{ exportandoPdf ? 'Generando...' : 'Exportar PDF' }}
      </button>

      <button 
        v-if="hasManejarHorariosPermission"
        class="btn bg-goethe-accent-claro sombra texto-principal d-flex align-items-center gap-2 text-nowrap" 
        @click="abrirModalRecesoMasivo"
      >
        <i class="bi bi-calendar-plus"></i>
        {{ t('nuevoHorarioDeReceso') }}
      </button>
      <button 
        v-if="hasManejarHorariosPermission"
        class="btn bg-goethe-accent-claro sombra texto-principal d-flex align-items-center gap-2 text-nowrap" 
        @click="abrirModalDiaNoLaborable"
      >
        <i class="bi bi-calendar-x"></i>
        {{ $t('diaNoLaborable') }}
      </button>
    </div>

    <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
      <img src="@/assets/LOADING.gif" style="width: 60px;" alt="Cargando..." />
    </div>
    <div v-if="personaSeleccionada" class="mt-4">
      <div class="d-flex gap-2 align-items-center ms-1 mb-2">
        <button
          class="p-2 d-flex align-items-center justify-content-center rounded bg-goethe-accent-claro-2 border-0 sombra-sm"
          :disabled="!hasAnterior"
          @click="irAnterior"
          title="Empleado Anterior"
          style="background: none;"
        >
          <svg width="20" height="20" viewBox="6 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg)">
            <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button
          class="p-2 d-flex align-items-center justify-content-center rounded bg-goethe-accent-claro-2 border-0 sombra-sm"
          :disabled="!hasSiguiente"
          @click="irSiguiente"
          title="Siguiente Empleado"
          style="background: none;"
        >
          <svg width="20" height="20" viewBox="6 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <router-link :to="`/personas/verDatosPersona?id=${personaSeleccionada.IdPersona}`" class="texto-principal text-decoration-none">
          <h4 class="m-0">{{ personaSeleccionada.Apellido }}, {{ personaSeleccionada.Nombre }}</h4>
        </router-link>
        <span class="badge fondo-terciario sombra-sm texto-principal border-0 ms-2">{{ $t('legajo') + ': ' + personaSeleccionada.LegajoIdEmpleado }}</span>
        <span class="badge fondo-terciario sombra-sm texto-principal border-0 ms-2">{{ $t('sector') + ': ' + personaSeleccionada.SectorNivel }}</span>
        <div class="ms-auto d-flex gap-2">
          
        </div>
      </div>
      <div v-if="!guardandoReceso && !guardandoDiaNoLaborable">
        <HorariosBackOfficeSection :persona="personaSeleccionada" :esPerfilPropio="false" :key="personaSeleccionada.IdPersona" class="mb-5" />
      </div>
    </div>
    
    <div v-else-if="!loading" class="alert alert-info text-center mt-4">
      <i class="bi bi-person-lines-fill me-2"></i>
      {{ t('noSeEncontraronEmpleados') }}
    </div>

    <div v-if="showModalReceso" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100 d-flex flex-column gap-4">
          <div class="d-flex justify-content-between align-items-center p-0">
            <h5 class="modal-title">{{ $t('asignarRecesoPorSectores') }}</h5>
            <button type="button" class="btn p-0" @click="cerrarModalReceso">
              <svg width="20" height="20" viewBox="5 5 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <rect id="Rectangle" fill-rule="nonzero" x="0" y="0" width="24" height="24"></rect>
                  <line x1="16.9999" y1="7" x2="7.00001" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
                  <line x1="7.00006" y1="7" x2="17" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
                </g>
              </svg>
            </button>
          </div>
          <div class="d-flex gap-2">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">{{ $t('horaDesde') }}</label>
                <input type="time" class="form-control" v-model="formReceso.HoraDesde" required>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{ $t('horaHasta') }}</label>
                <input type="time" class="form-control" v-model="formReceso.HoraHasta" required>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{ $t('periodoDesde') }}</label>
                <input type="date" class="form-control" v-model="formReceso.PeriodoDesde" required>
              </div>
              <div class="col-md-6">
                <label class="form-label">{{ $t('periodoHasta') }}</label>
                <input type="date" class="form-control" v-model="formReceso.PeriodoHasta" required>
              </div>
              <div class="col-12 mt-3">
                <label class="form-label fw-bold">{{ $t('sectoresAfectados') }}</label>
                <div class="rounded-2 p-2 fondo-terciario sombra-sm" style="max-height: 150px; overflow-y: auto;">
                  <div class="form-check" v-for="sector in sectoresDisponibles" :key="sector">
                    <input class="form-check-input" type="checkbox" :value="sector" :id="'sector-'+sector" v-model="formReceso.SectoresSeleccionados">
                    <label class="form-check-label" :for="'sector-'+sector">
                      {{ sector }}
                    </label>
                  </div>
                  <div v-if="sectoresDisponibles.length === 0" class="texto-secundario small">
                    {{ $t('noHaySectoresDisponibles') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex gap-2 justify-content-end">
            <button type="button" class="btn btn-secondary" @click="cerrarModalReceso">Cancelar</button>
            <button type="button" class="btn btn-primary" @click="guardarRecesoMasivo" :disabled="guardandoReceso || formReceso.SectoresSeleccionados.length === 0">
              {{ $t('guardar') }}
            </button>
            <div v-if="guardandoReceso" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
              <img src="@/assets/LOADING.gif" style="width: 60px;" alt="Cargando..." />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModalDiaNoLaborable" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100 d-flex flex-column gap-4">
          <div class="d-flex justify-content-between align-items-center p-0">
            <h5 class="modal-title">{{ $t('asignarDiaNoLaborablePorSectores') }}</h5>
            <button type="button" class="btn p-0" @click="cerrarModalDiaNoLaborable">
              <svg width="20" height="20" viewBox="5 5 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <rect id="Rectangle" fill-rule="nonzero" x="0" y="0" width="24" height="24"></rect>
                  <line x1="16.9999" y1="7" x2="7.00001" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
                  <line x1="7.00006" y1="7" x2="17" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
                </g>
              </svg>
            </button>
          </div>
          <div class="d-flex gap-2">
            <div class="row g-3">
              <div class="col-md-12 text-start">
                <label class="form-label fw-bold">{{ $t('fecha') }}</label>
                <input type="date" class="form-control" v-model="formDiaNoLaborable.Fecha" required>
              </div>
              <div class="col-12 mt-3 justify-content-start d-flex flex-column">
                <label class="form-label fw-bold">{{ $t('sectoresAfectados') }}</label>
                <div class="rounded-2 p-2 fondo-terciario" style="max-height: 150px; overflow-y: auto;">
                  <div class="form-check" v-for="sector in sectoresDisponibles" :key="'nl-'+sector">
                    <input class="form-check-input" type="checkbox" :value="sector" :id="'sector-nl-'+sector" v-model="formDiaNoLaborable.SectoresSeleccionados">
                    <label class="form-check-label" :for="'sector-nl-'+sector">
                      {{ $t(sector) }}
                    </label>
                  </div>
                  <div v-if="sectoresDisponibles.length === 0" class="texto-secundario small">
                    {{ $t('noHaySectoresDisponibles') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex gap-2 justify-content-end">
            <button type="button" class="btn btn-secondary" @click="cerrarModalDiaNoLaborable">{{ $t('cancelar') }}</button>
            <button type="button" class="btn btn-primary" @click="guardarDiaNoLaborableMasivo" :disabled="guardandoDiaNoLaborable || formDiaNoLaborable.SectoresSeleccionados.length === 0">
              {{ $t('guardar') }}
            </button>
            <div v-if="guardandoDiaNoLaborable" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
              <img src="@/assets/LOADING.gif" style="width: 60px;" alt="Cargando..." />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, onMounted, computed } from 'vue';
  import { useStore } from "vuex";
  import { useRouter } from "vue-router";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';
  import HorariosBackOfficeSection from '@/components/PersonasTabs/HorariosBackOfficeSection.vue';

export default {
  name: 'HorariosBackOfficePage',
  components: {
    HorariosBackOfficeSection,
  },
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    var hasManejarHorariosPermission = ref(false);
    var hasAdminHorariosPermission = ref(false);
    const personas = ref([]);
    const personaSeleccionada = ref(null);
    const searchQuery = ref('');
    const isDropdownOpen = ref(false);
    var loading = ref(false);
    const exportandoPdf = ref(false);

    // --- VARIABLES NUEVAS PARA RECESO MASIVO ---
    const showModalReceso = ref(false);
    const guardandoReceso = ref(false);
    const formReceso = ref({
      HoraDesde: '',
      HoraHasta: '',
      PeriodoDesde: '',
      PeriodoHasta: '',
      SectoresSeleccionados: []
    });

    const fetchPersonas = async () => {
      try {
        loading.value = true;
        const response = await api.get('/api/horarios/fichadas/personas');
        personas.value = response.data;
        personaSeleccionada.value = personas.value.length > 0 ? personas.value[0] : null;
        loading.value = false;
      } catch (error) {
        console.error("Error al cargar la lista de personas:", error);
        loading.value = false;
      }
    };

    const checkAuth = async () => {
      if (user.value && user.value.personasPermisos) {
        var permisoAComprobar = 'ManejarHorarios'
        if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) ||
            user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
        {
            hasManejarHorariosPermission.value = true;
        }

        permisoAComprobar = 'AdminHorarios'
        if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) ||
            user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
        {
            hasAdminHorariosPermission.value = true;
        }

        if (!hasManejarHorariosPermission.value && !hasAdminHorariosPermission.value) {
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
      }
    };

    const descargarPdf = async () => {
      // Tomamos las fechas directamente del localStorage
      const storedDesde = localStorage.getItem('filtroPeriodoDesdeRRHH');
      const storedHasta = localStorage.getItem('filtroPeriodoHastaRRHH');

      // Validamos que existan
      if (!storedDesde || !storedHasta) {
        alert("No se encontró un período seleccionado. Por favor, asegúrese de tener fechas configuradas en el filtro.");
        return;
      }
      
      exportandoPdf.value = true;
      try {
        const response = await api.get('/api/horarios/fichadas/exportar-pdf', {
          params: {
            fechaDesde: storedDesde,
            fechaHasta: storedHasta
          },
          responseType: 'blob' // Clave para manejar binarios
        });

        // Generamos la descarga
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Informe_Masivo_${storedDesde}_al_${storedHasta}.pdf`);
        document.body.appendChild(link);
        link.click();
        
        // Limpiamos
        link.remove();
        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.error("Error al descargar PDF:", error);
        alert("Ocurrió un error al intentar generar el PDF.");
      } finally {
        exportandoPdf.value = false;
      }
    };

    // --- LÓGICA DE BÚSQUEDA Y NAVEGACIÓN (Original) ---
    const personasFiltradas = computed(() => {
      if (!searchQuery.value) return personas.value;
      const query = searchQuery.value.toLowerCase();
      return personas.value.filter(p =>
        (p.Apellido && p.Apellido.toLowerCase().includes(query)) ||
        (p.Nombre && p.Nombre.toLowerCase().includes(query)) ||
        (p.LegajoIdEmpleado && p.LegajoIdEmpleado.includes(query))
      );
    });

    const seleccionarPersona = (persona) => {
      searchQuery.value = '';
      personaSeleccionada.value = persona;
      isDropdownOpen.value = false;
    };

    const limpiarSeleccion = () => {
      searchQuery.value = '';
      isDropdownOpen.value = true; 
      document.getElementById('buscadorPersona').focus();
    };

    const cerrarDropdown = () => {
      setTimeout(() => {
        isDropdownOpen.value = false;
        if (!personaSeleccionada.value) {
          searchQuery.value = '';
        }
      }, 400);
    };

    const currentIndex = computed(() => {
      if (!personaSeleccionada.value) return -1;
      return personas.value.findIndex(p => p.IdPersona === personaSeleccionada.value.IdPersona);
    });

    const hasAnterior = computed(() => currentIndex.value > 0);
    const hasSiguiente = computed(() => currentIndex.value !== -1 && currentIndex.value < personas.value.length - 1);

    const irAnterior = () => {
      if (hasAnterior.value) seleccionarPersona(personas.value[currentIndex.value - 1]);
    };
    const irSiguiente = () => {
      if (hasSiguiente.value) seleccionarPersona(personas.value[currentIndex.value + 1]);
    };

    // --- LÓGICA DE RECESO MASIVO ---
    
    // Obtener lista única de sectores de los empleados
    const sectoresDisponibles = computed(() => {
      const sectores = personas.value
        .map(p => p.SectorNivel)
        .filter(sector => sector !== null && sector !== undefined && sector.trim() !== '');
      return [...new Set(sectores)].sort(); 
    });

    const abrirModalRecesoMasivo = () => {
      const hoy = new Date().toISOString().split("T")[0];
      formReceso.value = {
        HoraDesde: '',
        HoraHasta: '',
        PeriodoDesde: hoy,
        PeriodoHasta: '',
        SectoresSeleccionados: []
      };
      showModalReceso.value = true;
    };

    const cerrarModalReceso = () => {
      showModalReceso.value = false;
    };

    const guardarRecesoMasivo = async () => {
      if (!formReceso.value.HoraDesde || !formReceso.value.HoraHasta || !formReceso.value.PeriodoDesde || !formReceso.value.PeriodoHasta) {
        alert("Por favor, completa todas las fechas y horas.");
        return;
      }

      if (formReceso.value.HoraDesde > formReceso.value.HoraHasta) {
        alert('La Hora Desde no puede ser mayor a la Hora Hasta.');
        return;
      }

      if (formReceso.value.PeriodoDesde > formReceso.value.PeriodoHasta) {
        alert('El Periodo Desde no puede ser mayor al Periodo Hasta.');
        return;
      }

      guardandoReceso.value = true;

      // Filtrar empleados que pertenezcan a los sectores seleccionados
      const empleadosAfectados = personas.value.filter(p => 
        formReceso.value.SectoresSeleccionados.includes(p.SectorNivel)
      );

      const horaDesdeF = formReceso.value.HoraDesde.length === 5 ? `${formReceso.value.HoraDesde}:00` : formReceso.value.HoraDesde;
      const horaHastaF = formReceso.value.HoraHasta.length === 5 ? `${formReceso.value.HoraHasta}:00` : formReceso.value.HoraHasta;

      let payloads = [];

      // Armar el payload para cada empleado afectado (Lunes a Viernes: dias 1 al 5)
      empleadosAfectados.forEach(emp => {
        for (let i = 1; i <= 5; i++) {
          payloads.push({
            IdPersona: emp.IdPersona,
            HoraDesde: horaDesdeF,
            HoraHasta: horaHastaF,
            PeriodoDesde: formReceso.value.PeriodoDesde,
            PeriodoHasta: formReceso.value.PeriodoHasta,
            EsHomeOffice: false,
            EsVacaciones: false,
            TipoLicencia: null,
            Dia: i // Crea el registro para Lunes, Martes, Miércoles, Jueves y Viernes
          });
        }
      });
      console.log('Payloads a enviar:', payloads);
      try {
        await api.post(`api/horarios/backOffice`, payloads);
        alert(`Receso asignado correctamente a ${empleadosAfectados.length} empleado(s).`);
        cerrarModalReceso();
        
        // (Opcional) Si necesitas refrescar los datos del empleado seleccionado actualmente
        // if (personaSeleccionada.value) { /* lógica para recargar su componente hijo */ }
        
      } catch (error) {
        console.error('Error al guardar el receso masivo:', error);
        alert('Hubo un error al guardar los horarios.');
      } finally {
        guardandoReceso.value = false;
      }
    };

    // --- VARIABLES NUEVAS PARA DÍA NO LABORABLE ---
    const showModalDiaNoLaborable = ref(false);
    const guardandoDiaNoLaborable = ref(false);
    const formDiaNoLaborable = ref({
      Fecha: '',
      SectoresSeleccionados: []
    });

    // --- MÉTODOS PARA DÍA NO LABORABLE ---
    const abrirModalDiaNoLaborable = () => {
      const hoy = new Date().toISOString().split("T")[0];
      formDiaNoLaborable.value = {
        Fecha: hoy,
        SectoresSeleccionados: []
      };
      showModalDiaNoLaborable.value = true;
    };

    const cerrarModalDiaNoLaborable = () => {
      showModalDiaNoLaborable.value = false;
    };

    const guardarDiaNoLaborableMasivo = async () => {
      if (!formDiaNoLaborable.value.Fecha) {
        alert("Por favor, selecciona una fecha.");
        return;
      }

      guardandoDiaNoLaborable.value = true;

      // Filtrar empleados que pertenezcan a los sectores seleccionados
      const empleadosAfectados = personas.value.filter(p => 
        formDiaNoLaborable.value.SectoresSeleccionados.includes(p.SectorNivel)
      );

      let payloads = [];

      // Armar el payload para cada empleado afectado
      // En este caso es 1 SOLO registro por persona (Dia: 0)
      empleadosAfectados.forEach(emp => {
        payloads.push({
          IdPersona: emp.IdPersona,
          HoraDesde: null, // Sin hora
          HoraHasta: null, // Sin hora
          PeriodoDesde: formDiaNoLaborable.value.Fecha, // Misma fecha para desde y hasta
          PeriodoHasta: formDiaNoLaborable.value.Fecha, 
          EsHomeOffice: false,
          EsVacaciones: false,
          TipoLicencia: 'diaNoLaborable',
          Dia: 0 // Comodín 0
        });
      });

      try {
        await api.post(`api/horarios/backOffice`, payloads);
        alert(`Día no laborable asignado correctamente a ${empleadosAfectados.length} empleado(s).`);
        cerrarModalDiaNoLaborable();
        
      } catch (error) {
        console.error('Error al guardar el día no laborable:', error);
        alert('Hubo un error al guardar los horarios.');
      } finally {
        guardandoDiaNoLaborable.value = false;
      }
    };

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0];
      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload();
      }
      
      checkAuth();
      fetchPersonas();
    });

    return {
      checkAuth,
      t,
      hasManejarHorariosPermission,
      personas,
      personaSeleccionada,
      searchQuery,
      isDropdownOpen,
      personasFiltradas,
      seleccionarPersona,
      limpiarSeleccion,
      cerrarDropdown,
      hasAnterior,
      hasSiguiente,
      irAnterior,
      irSiguiente,
      showModalReceso,
      formReceso,
      sectoresDisponibles,
      guardandoReceso,
      abrirModalRecesoMasivo,
      cerrarModalReceso,
      guardarRecesoMasivo,
      showModalDiaNoLaborable,
      guardandoDiaNoLaborable,
      formDiaNoLaborable,
      abrirModalDiaNoLaborable,
      cerrarModalDiaNoLaborable,
      guardarDiaNoLaborableMasivo,
      loading,
      exportandoPdf,
      descargarPdf,
      hasAdminHorariosPermission
    };
  },
};
</script>

<style>
.permissions-list {
  margin-top: 10px;
}

.roles-column {
  width: 250px; /* Fixed width for roles column */
}
</style>

